"use client";

import Link from "next/link";
import { useSession } from "next-auth/react";
import { redirect } from "next/navigation";
import { useState } from "react";

export default function Register() {
  const { data: session, status } = useSession();
  const isLoggedIn = status === "authenticated";

  if(isLoggedIn) {
    redirect("/")
  }
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  async function handleRegister(event: React.FormEvent<HTMLFormElement>) {

    event.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    // Call your backend API route to create the user
    // e.g. POST /api/auth/register - you need to implement this endpoint separately
    try {
      const response = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();

      if (response.ok) {
        setMessage(`Welcome, ${data.email}! Your account has been created.`);
        setEmail("");
        setPassword("");
        setConfirm("");
      } else {
        setError(data.message || "Failed to register");
      }
    } catch (err) {
      setError("Unexpected error occurred");
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[rgba(249,115,22,0.2)] border-2 border-[rgba(249,115,22,0.2)] rounded-xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-white mb-6 text-center">Register</h2>

        {error && (
          <p className="border-2 border-[rgba(200,0,0,0.8)] bg-[rgba(200,0,0,0.3)] text-[rgb(200,0,0)] rounded-lg p-2 my-3">{error}</p>
        )}
        {message && (
          <p className="border-2 border-[rgba(0,200,0,0.8)] bg-[rgba(0,200,0,0.3)] text-[rgb(0,200,0)] rounded-lg p-2 my-3">{message}</p>
        )}

        <form className="space-y-5" onSubmit={handleRegister}>
          <div>
            <label className="block mb-1 text-gray-300 text-sm font-extrabold">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
              value={email}
              placeholder="john@example.com"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-300 text-sm font-extrabold">Password</label>
            <input
              type="password"
              className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
              value={password}
              placeholder="************"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-gray-300 text-sm font-extrabold">Confirm Password</label>
            <input
              type="password"
              className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
              value={confirm}
              placeholder="************"
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 px-4 rounded-lg text-white font-semibold border-2 border-orange-600 bg-orange-400 hover:bg-orange-600 transition-all duration-200 ease-linear"
          >
            Register
          </button>
        </form>

        <p className="text-sm text-gray-400 mt-6 text-center">
          Already have an account?{" "}
          <Link href="../auth/login" className="text-orange-400 hover:underline">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}
